import { render } from "./SocialList.vue?vue&type=template&id=18613c3b&scoped=true&ts=true"
import script from "./SocialList.vue?vue&type=script&lang=ts"
export * from "./SocialList.vue?vue&type=script&lang=ts"

import "./SocialList.vue?vue&type=style&index=0&id=18613c3b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18613c3b"]])

export default __exports__